import React, { useEffect, useState } from 'react'
import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import PaginationButtons from './components/PaginationButtons'
import NoticeList from './components/NoticeList'

const Notice = () => {
    const [listData, setListData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;

    useEffect(() => {
        const fetchNotices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/boards/notices?page=${currentPage}&size=${pageSize}`);
                const data = await response.json();

                setListData(data.results);
                setTotalPages(data.total_pages);

            } catch (error) {
                console.error('Error fetching notices:', error);
            }
        }
        fetchNotices();
    }, [currentPage]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    return (
        <>
            <section className='notice-section'>
                <CommonBox heading=" 공지사항 " englishHeading=" notice" isEnglishHeadingOnMobile={true} isAuthenticated={true}>
                    <NoticeList listData={listData} />
                    <PaginationButtons totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>
        </>
    )
}

export default Notice